.PortfolioTile {
  border: 1px solid #777;
  color: #777;
  padding: 8px 16px;
  border-radius: 8px;
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  & > :global(.label) {
    position: absolute;
    font-size: 0.75rem;
    top: -10px;
    left: 10px;
    background-color: white;
    padding: 0 0.25rem;
  }

  & > :global(.main) {
    font-size: 2rem;
    font-weight: bold;
    padding-right: 10px;
  }

  & > :global(.positive) {
    color: green;
  }
  & > :global(.negative) {
    color: red;
  }
  & > :global(.neutral) {
    color: gray;
  }
}
